export default "__VITE_ASSET__pBBTIP0L__"